/**
 * The Services tab a URL asks for. `roster` is left out: it is a view with no tab to reach it.
 * `primary` and `secondary` were tabs of their own and now land on Current, so old links still open.
 */
export const servicesTabFromSearch = (tab: unknown): 'current' | 'historical' | undefined => {
	if (tab === 'historical') return 'historical';
	if (tab === 'current' || tab === 'primary' || tab === 'secondary') return 'current';
	return undefined;
};
